module.exports = __webpack_public_path__ + "img/logo3.3172d28c.png";